import { Link } from "react-router-dom";
import { allMedia } from "@/utils/media";

export default function SidebarRecommend() {
  const hot = [...allMedia].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const latest = [...allMedia].sort((a, b) => b.year - a.year || b.rating - a.rating).slice(0, 6);

  return (
    <div className="space-y-5">
      <section className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-3 flex items-center gap-2 border-b-2 border-background-200 pb-2.5">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-500 text-primary-950">
            <i className="ri-fire-line text-sm" />
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-900">热门推荐</h2>
        </div>
        <ul className="space-y-1">
          {hot.map((item, i) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="group flex items-center gap-3 rounded-md px-2 py-2 transition-colors hover:bg-background-100">
                <span
                  className={`flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    i < 3 ? "bg-accent-500 text-primary-950" : "bg-background-200 text-foreground-500"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-700">
                  {item.title}
                </span>
                <span className="shrink-0 text-xs font-semibold text-accent-600">{item.rating.toFixed(1)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
        <div className="mb-3 flex items-center gap-2 border-b-2 border-background-200 pb-2.5">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-500 text-background-50">
            <i className="ri-time-line text-sm" />
          </span>
          <h2 className="font-heading text-lg font-bold text-foreground-900">最新影视推荐</h2>
        </div>
        <ul className="space-y-3">
          {latest.map((item) => (
            <li key={item.id}>
              <Link to={`/detail/${item.id}`} className="group flex items-center gap-3">
                <div className="h-[68px] w-12 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title}海报`}
                    title={`${item.title}最新推荐`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-800 transition-colors group-hover:text-primary-700">
                    {item.title}
                  </h3>
                  <p className="mt-1 truncate text-xs text-foreground-400">
                    {item.type === "movie" ? "电影" : `电视剧 · ${item.episodes}集`} · {item.year}
                  </p>
                  <span className="mt-1 inline-block rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-700">
                    {item.genres[0]}
                  </span>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}